// helpers
import { flow, filter, map } from 'lodash/fp';
import { sessionST } from 'lib/sessionStorage';

const TranslationOptionFactory = (option) => ({
  value: option.code,
  label: option.name,
});

export const TranslateValueAdapter = (value) => (value === 'he' ? 'iw' : value);

const removeHeOption = (option) => option.code !== 'he';

export const TranslationListAdapter = (translations = []) =>
  flow(filter(removeHeOption), map(TranslationOptionFactory))(translations);

export const getTranslationsFromSessionStorage = () => {
  const translations = sessionST().availableTranslationList().get();

  return JSON.parse(translations);
};

export const setTranslationsInSessionStorage = (traslations) =>
  sessionST().availableTranslationList().set(JSON.stringify(traslations));

export const isLocalesEqual = (from, to) => from === to;

const getTranslationOptionID = (userID) => `preferredtranslationOption-${userID}`;

export const getOptionFromLS = (userID) => window.localStorage.getItem(getTranslationOptionID(userID));
export const setOptionToLS = (userID, value) => {
  window.localStorage.setItem(getTranslationOptionID(userID), value);
};
